// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react: true*/
import React, {Fragment, useEffect, useMemo, useRef, useState} from 'react';
import {type i_lottie_props} from './types';

export const Lottie = (props: i_lottie_props)=>{
    const Lottie_tag = 'lottie-player' as any;
    const ref = useRef<any>();
    const [lot, set_lot] = useState(null);
    const memo_state = useMemo(()=>({lottie: {
        current_frame: 0,
        animation: props.animation,
        animation_step: 0,
        loop: props.loop,
        direction: props.direction,
        fixed_frame: props.fixed_frame,
    }}), []);
    useEffect(()=>{
        // @ts-ignore
        import('@lottiefiles/lottie-player');
    }, []);
    useEffect(()=>{
        const clb = ()=>{
            if (!props.autoplay)
            {
                ref.current.play();
                ref.current.stop();
            }
            if (props.on_create)
                props.on_create(ref.current);
        };
        const wait = ()=>{
            if (ref.current && ref.current.play && ref.current._lottie)
            {
                clb();
                if (!ref.current._lottie ||
                    !ref.current._lottie.addEventListener)
                {
                    return;
                }
                ref.current._lottie.addEventListener('enterFrame', event=>{
                    if (!memo_state.lottie.animation)
                    {
                        const current_time = Math.round(event.currentTime)+1;
                        if (event.totalTime<=current_time
                            && !memo_state.lottie.loop)
                        {
                            ref.current.pause();
                        }
                        return;
                    }
                    const c_step = memo_state.lottie.animation_step;
                    const a_obj = memo_state.lottie.animation[c_step];
                    const a = a_obj.frames;
                    const direction = a_obj.direction;
                    const loop = a_obj.loop;
                    const current = Math.round(event.currentTime);
                    if (!a)
                        return;
                    if (memo_state.lottie.fixed_frame !== undefined)
                        return;
                    if (a.from<a.to && direction==1 &&
                        current>=a.to ||
                        a.from<a.to && direction==1 &&
                        current<a.to && current<a.from ||
                        a.from<a.to && direction==-1 &&
                        current<=a.to && current>a.from ||
                        a.from>a.to && direction==1 &&
                        current>=a.to && current<a.from ||
                        a.from>a.to && direction==-1 &&
                        current<=a.to ||
                        a.from>a.to && direction==-1 &&
                        current>a.to && current>a.from)
                    {
                        if (loop)
                            ref.current.seek(a.from);
                        else
                        {
                            ref.current.pause();
                            if (memo_state.lottie.animation.length-1 > c_step)
                            {
                                memo_state.lottie.animation_step++;
                                const next = memo_state.lottie
                                    .animation[c_step].frames;
                                ref.current.seek(next.from);
                                ref.current.play();
                            }
                            else if (current!=a.to)
                                ref.current.seek(a.to);
                        }
                    }
                });
                set_lot(ref.current._lottie);
            }
            else
                setTimeout(()=>wait(), 50);
        };
        wait();
    }, []);
    useEffect(()=>{
        if (props.animation && props.animation[0].frames && lot &&
            props.fixed_frame===undefined)
        {
            ref.current.pause();
            memo_state.lottie.animation = props.animation;
            memo_state.lottie.animation_step = 0;
            ref.current.seek(props.animation[0].frames.from);
            ref.current.setDirection(props.animation[0].direction);
            ref.current.play();
        }
    }, [JSON.stringify(props.animation), lot, props.fixed_frame]);
    useEffect(()=>{
        if (!lot || !ref.current)
            return;
        const prev = memo_state.lottie.fixed_frame;
        memo_state.lottie.fixed_frame = props.fixed_frame;
        if (prev!==undefined && props.fixed_frame===undefined && props.loop)
            return void ref.current.play();
        if (props.fixed_frame!==undefined)
        {
            ref.current.pause();
            ref.current.seek(props.fixed_frame);
        }
    }, [props.fixed_frame, ref.current, lot, props.loop]);
    const props_ = {} as any;
    if (props.loop)
        props_.loop = true;
    if (props.autoplay)
        props_.autoplay = true;
    return <Fragment>
      {!lot && props.fallback_svg}
      <Lottie_tag class={props.cls} src={props.src}
        background="transparent" title={props.title}
        speed={props.speed||'1'}
        style={{width: props.width, height: props.height}}
        ref={ref}
        {...props_}
        onMouseEnter={props.on_mouse_enter} onClick={props.on_click}
        onMouseLeave={props.on_mouse_leave}/>
    </Fragment>;
};
